/**
 * Donations tab: the active channel's current-broadcast donations.
 *
 * Per-broadcast history is a later addition; for now this shows the channel's
 * live/most-recent session. The active channel comes from the switcher via the
 * Outlet context.
 */
import { useOutletContext } from "react-router-dom";
import type { ChannelContext } from "../components/Layout";
import { DonationSection } from "../components/DonationSection";

export function Donations() {
  const { channelId } = useOutletContext<ChannelContext>();
  // No channel selected — the Layout banner explains why.
  if (!channelId) return null;
  return <DonationSection channelId={channelId} label="Donations" />;
}
